import { Id, Identifiable, Task } from "@planzone/dto";
import { LinkedTask, Linker } from "../linkers/types";
import { formatDate } from "../utils/formatDate";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function editTask(httpClient: HttpClient, linker: Linker) {
  return (task: Identifiable<Task>, nextTask: Task) =>
    httpClient
      .sendHttpRequest<
        LinkedTask & {
          modifiedElements?: {
            tasks?: { uuid: Id; endDate: string; startDate: string }[];
            activities?: {
              uuid: Id;
              endDate: string;
              startDate: string;
              minStartDate?: string;
              maxStartDate?: string;
              minEndDate?: string;
              maxEndDate?: string;
            }[];
            milestones?: { uuid: Id; endDate: string; startDate: string }[];
          };
        }
      >({
        endpoint: `/tasks/${task.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          name: nextTask.name,
          description: nextTask.description,
          ...(nextTask.startDate
            ? {
                startDate: formatDate(nextTask.startDate),
              }
            : nextTask.startDate === "" && { startDate: null }),
          ...(nextTask.endDate
            ? { endDate: formatDate(nextTask.endDate) }
            : nextTask.endDate === "" && { endDate: null }),
          percentComplete: nextTask.percentComplete,
          activityKeyRank: nextTask.activityKeyRank,
          completionDate: nextTask.completionDate,
          statusKeyRank: nextTask.statusKeyRank,
          ...(task.status.uuid !== nextTask.status.uuid && {
            status: `/statuses/${nextTask.status.uuid}`,
          }),
          ...(!!nextTask.attributes && {
            attributes: nextTask.attributes,
          }),
        },
      })
      .then((editedTask) => ({
        ...editedTask,
        tags: editedTask.tags
          ? editedTask.tags.map((tag) => {
              // @ts-ignore
              return typeof tag === "string" ? { name: tag } : tag;
            })
          : [],
        impactedElements: (!!editedTask.modifiedElements
          ? [
              ...(editedTask.modifiedElements.tasks || []).map((t) => ({
                ...t,
                type: "task",
              })),
              ...(editedTask.modifiedElements.activities || []).map((t) => ({
                ...t,
                type: "list",
              })),
              ...(editedTask.modifiedElements.milestones || []).map((t) => ({
                ...t,
                type: "milestone",
              })),
            ]
          : []) as {
          type: "task" | "list" | "milestone";
          uuid: Id;
          endDate: string;
          startDate: string;
          minStartDate?: string;
          maxStartDate?: string;
          minEndDate?: string;
          maxEndDate?: string;
        }[],
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            invalidDateRange: "invalidDateRange",
            startDateOutOfBound: "startDateOutOfBound",
            notFound: "notFound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { editTask };
